import { useFeatureIsOn } from '@growthbook/growthbook-react'
import React, { useEffect, useState } from 'react'
import { Tabs, Spin } from 'antd'
import { connect } from 'react-redux'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useQuery } from 'modules/core/customHooks'
import { SiderLayout } from 'modules/core/layouts'
import { PeriodNavigator } from 'modules/core/components'
import { isUserAllowed, getOperationsByKeys } from 'modules/core/utils'
import { ROLES, CONCEPTS, PROJECTION } from 'modules/core/constants'
import configuration from 'modules/configuration'
import GlobalForecastList from '../GlobalForecastList/GlobalForecastList'
import ForecastList from '../ForecastList/ForecastList'
import _ from 'lodash'

const {
  FORECAST__EXPENSES,
  FORECAST__SALES,
  FORECAST__HUMAN_RESOURCES,
  FORECAST__COSTS,
  FORECAST__GLOBAL_FORECAST,
  FORECAST__OTHER_5,
  FORECAST__OTHER_6,
  FORECAST__OTHER_7,
  FORECAST__OTHER_8,
} = ROLES

const ForecastHome = ({ budgetTypeList, fetchBudgetTypeList }) => {
  const extraConcept = useFeatureIsOn('feature-extra-concept')
  let { periodId, forecastId, conceptName } = useParams()
  const [isScreenLoading, setIsScreenLoading] = useState(false)
  const [tabKey, setTabKey] = useState(conceptName || 'Ventas')
  const { t } = useTranslation()
  let query = useQuery()

  let queryString = window.location.search
  let urlParams = new URLSearchParams(queryString)
  let tabUrl = urlParams.get('tab')

  const auxKey = window.location.pathname.replaceAll('/', '-')
  const key = !auxKey.includes('?tab=') ? `?tab=${tabKey}` : ''

  useEffect(() => {
    setIsScreenLoading(true)
    fetchBudgetTypeList().then((response) => {
      const aux = response.payload.data.concepts.filter((el) => PANEL__ACCESS[el.id])
      getTabKey(aux)
      setIsScreenLoading(false)
    })
    // eslint-disable-next-line
  }, [fetchBudgetTypeList, tabUrl])

  const PANEL__ACCESS = {
    [PROJECTION.GLOBAL_FORECAST]: isUserAllowed(getOperationsByKeys([FORECAST__GLOBAL_FORECAST])),
    [CONCEPTS.IDS.SALES_ID]: isUserAllowed(getOperationsByKeys([FORECAST__SALES])),
    [CONCEPTS.IDS.EXPENSES_ID]: isUserAllowed(getOperationsByKeys([FORECAST__EXPENSES])),
    [CONCEPTS.IDS.COSTS_ID]: isUserAllowed(getOperationsByKeys([FORECAST__COSTS])),
    [CONCEPTS.IDS.HUMAN_RESOURCES_ID]: isUserAllowed(
      getOperationsByKeys([FORECAST__HUMAN_RESOURCES]),
    ),
    [CONCEPTS.IDS.OTHER_5_ID]: isUserAllowed(getOperationsByKeys([FORECAST__OTHER_5])),
    [CONCEPTS.IDS.OTHER_6_ID]: isUserAllowed(getOperationsByKeys([FORECAST__OTHER_6])),
    [CONCEPTS.IDS.OTHER_7_ID]: isUserAllowed(getOperationsByKeys([FORECAST__OTHER_7])),
    [CONCEPTS.IDS.OTHER_8_ID]: isUserAllowed(getOperationsByKeys([FORECAST__OTHER_8])),
  }

  const verifyPermission = (concept) => {
    const permission = [
      PROJECTION.GLOBAL_FORECAST.toString(),
      CONCEPTS.IDS.SALES_ID.toString(),
      CONCEPTS.IDS.EXPENSES_ID.toString(),
      CONCEPTS.IDS.COSTS_ID.toString(),
      CONCEPTS.IDS.HUMAN_RESOURCES_ID.toString(),
      CONCEPTS.IDS.OTHER_5_ID.toString(),
      CONCEPTS.IDS.OTHER_6_ID.toString(),
      CONCEPTS.IDS.OTHER_7_ID.toString(),
      CONCEPTS.IDS.OTHER_8_ID.toString(),
    ]
    const value = PANEL__ACCESS[concept.id]
    if (value === undefined && !permission.includes(concept.id.toString()) && extraConcept) {
      return true
    }

    return value
  }

  const filterByRole = budgetTypeList?.values.filter((el) => verifyPermission(el))

  const showDefaultPanelKey = (firstElement) => {
    if (firstElement && verifyPermission(firstElement)) {
      return firstElement.name
    } else if (PANEL__ACCESS[PROJECTION.GLOBAL_FORECAST]) {
      return PROJECTION.GLOBAL_FORECAST
    }
  }

  const getTabKey = (data) => {
    if (_.isEmpty(data)) {
      setTabKey('Ventas')
    } else {
      if (
        data.find((el) => el.name === conceptName) ||
        conceptName === PROJECTION.GLOBAL_FORECAST
      ) {
        setTabKey(conceptName)
      } else {
        setTabKey(showDefaultPanelKey(data[0]))
      }
    }
  }

  const renderHeader = () => (
    <PeriodNavigator
      items={[
        { name: t('LABEL_FORECAST'), url: `/forecast/${periodId}` },
        {
          name: `${t('LABEL_DETAIL')}: ${t('LABEL_FORECAST')}`,
          // ${
          //   forecastDetail.name ? forecastDetail.name : ''
          // }`,
        },
      ]}
    />
  )

  const handleClick = (key) => {
    setTabKey(key)
    window.history.replaceState(null, '', `/forecast/${periodId}/${forecastId}/${key}`)
  }

  return (
    <SiderLayout extraKey={key}>
      <Spin spinning={isScreenLoading} size="large" />
      {!isScreenLoading && renderHeader()}
      {!isScreenLoading && (
        <Tabs defaultActiveKey={tabKey} onChange={(key) => handleClick(key)} size="small">
          {budgetTypeList?.values.map(
            (concept) =>
              verifyPermission(concept) && (
                <Tabs.TabPane tab={t(concept.name)} key={concept.name}>
                  {tabKey === concept.name && (
                    <ForecastList periodId={periodId} concept={concept} />
                  )}
                </Tabs.TabPane>
              ),
          )}
          {PANEL__ACCESS[PROJECTION.GLOBAL_FORECAST] && (
            <Tabs.TabPane tab={t('LABEL_GLOBAL_FORECAST')} key={PROJECTION.GLOBAL_FORECAST}>
              <GlobalForecastList />
            </Tabs.TabPane>
          )}
        </Tabs>
      )}
    </SiderLayout>
  )
}

const mapStateToProps = (state) => ({
  budgetTypeList: configuration.selectors.getBudgetTypeList(state),
})

const mapDispatchToProps = {
  fetchBudgetTypeList: configuration.actions.fetchBudgetTypeList,
}

export default connect(mapStateToProps, mapDispatchToProps)(ForecastHome)
